import { prettifyEnumLabel } from "../../../utils";
import { GraphQLTableColumn } from "../../GraphQL";
import { FilterOperatorEnum } from "../../GraphQL/innerTypes";

export type EnumColumnTemplateParams<T extends object = {}> = GraphQLTableColumn<T> & {
  toLabel?: (v?: any) => string | null | undefined,
  allowEmpty?: boolean
};

export function EnumColumnTemplate<T extends object = {}>(params?: EnumColumnTemplateParams<T>): GraphQLTableColumn<T> {
  const currentToLabel = params?.toLabel || prettifyEnumLabel;

  return {
    Header: "",
    filterOperator: FilterOperatorEnum.In,
    filterValueModifier: value => Array.isArray(value)
      ? (value?.length ? value : undefined)
      : value,
    Cell: ({ value, bodyCellProps }: any) => {
      const prettified = currentToLabel(value);
      return <span title={prettified} {...bodyCellProps}>{prettified}</span>;
    },
    ...params,
    excelProps: {
      valueModifier: currentToLabel,
      filterButton: true,
      ...params?.excelProps,
    },
  };
}

export default EnumColumnTemplate;
